import React, {Component} from 'react';
import Header from '../../../Containers/Header/Header';
import Footer from '../../../Containers/Footer';
import Loading from "../../../Containers/Loading";
import MobileNumber from "./MobileNumber";

class AttendanceMain extends Component {
    state = {
        // loading
        isLoadingHide: false
    }

    componentDidMount() {
        this.setState({
            isLoadingHide: true
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return (
            <div className="beaconWrapper">
                <Header selectedIndex={0}/>
                <MobileNumber/>
                <Footer/>
            </div>
        );
    }
}

export default AttendanceMain;


// WEBPACK FOOTER //
// ./src/components/Pages/Attendance/AttendanceMain/index.js